import LocalizedMessage from '../common/LocalizedMessage';
import React, { useState } from "react";
import PropTypes from "prop-types";
import Input from "../common/Input";
import { STATUS } from "../common/Const";
import { useTranslation } from 'react-i18next';

function SsoProfileCompletion({
  email, firstName, lastName, onSubmit,
}) {
  const { t: tr } = useTranslation();
  const [formData, setFormData] = useState({
    firstName,
    lastName,
    mobile: "",
  });
  const [status, setStatus] = useState(STATUS.IDLE);
  const [error, setError] = useState("");

  const handleChange = (event) => {
    setFormData({ ...formData, [event.target.name]: event.target.value });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const missingField = [
      { name: "firstName", message: tr("common:firstNameRequired") },
      { name: "lastName", message: tr("common:lastNameRequired") },
      { name: "mobile", message: tr("common:phoneRequired") },
    ].find(field => !formData[field.name].trim());

    if (missingField) {
      setError(missingField.message);
      setStatus(STATUS.SUBMITTED);
      return;
    }

    setStatus(STATUS.SUBMITTING);
    onSubmit({
      firstName: formData.firstName.trim(),
      lastName: formData.lastName.trim(),
      mobile: formData.mobile.trim(),
    })
      .catch((submitError) => {
        setError(submitError.message);
        setStatus(STATUS.SUBMITTED);
      });
  };

  return (
    <div className="quiz-text">
      <h2><strong>{tr("auth:completeProfile")}</strong></h2>
      <p>{email}</p>
      {error && status === STATUS.SUBMITTED && <div role="alert" className="alert alert-danger"><LocalizedMessage isError value={error} /></div>}
      <form onSubmit={handleSubmit}>
        <div className="form-row">
          <div className="col-md-9 col-lg-7">
            <Input
              label={tr("common:firstName")}
              name="firstName"
              value={formData.firstName}
              onChange={handleChange}
              error={error && !formData.firstName.trim() ? error : undefined}
              placeholder={tr("common:firstName")}
            />
          </div>
        </div>
        <div className="form-row">
          <div className="col-md-9 col-lg-7">
            <Input
              label={tr("common:lastName")}
              name="lastName"
              value={formData.lastName}
              onChange={handleChange}
              error={error && !formData.lastName.trim() ? error : undefined}
              placeholder={tr("common:lastName")}
            />
          </div>
        </div>
        <div className="form-row">
          <div className="col-md-9 col-lg-7">
            <Input
              label={tr("common:phone")}
              name="mobile"
              value={formData.mobile}
              onChange={handleChange}
              error={error && !formData.mobile.trim() ? error : undefined}
              placeholder={tr("common:phone")}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-3 mb-2">
            <button type="submit" className="btn manage-button manage-red-button btn-block" disabled={status === STATUS.SUBMITTING}>{tr("common:continue")}</button>
          </div>
        </div>
      </form>
    </div>
  );
}

SsoProfileCompletion.propTypes = {
  email: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
};

SsoProfileCompletion.defaultProps = {
  email: "",
  firstName: "",
  lastName: "",
};

export default SsoProfileCompletion;
